import { dashboardActions } from './dashboardSlice'
import { fetchCachedHelper } from '../../api/api'
import {
    fetchTopSellingClasses,
    fetchTopSellingCourses,
} from '../../api/topSellingApi'
import { fetchUserCourses } from '../Course/userCoursesApi'

export const getRecommendedCourses = email => async dispatch => {
    dispatch(dashboardActions.getRecommendedCourses())
    try {
        const response = await fetchCachedHelper(
            `Customercourse/RecommendedCourses/${email}`
        )
        let courses = response.data
        const courseDetailsRes = await Promise.all(
            courses.map(({ coursecode }) =>
                fetchCachedHelper(`Course/${coursecode}`)
            )
        )

        courses = courses.map((course, idx) => ({
            ...course,
            ...courseDetailsRes[idx].data,
        }))

        dispatch(dashboardActions.getRecommendedCoursesSuccess(courses))
    } catch (e) {
        dispatch(dashboardActions.getRecommendedCoursesError())
    }
}

export const getOurCourses = () => async dispatch => {
    dispatch(dashboardActions.getOurCourses())
    try {
        const courses = await fetchTopSellingCourses()
        dispatch(dashboardActions.getOurCoursesSuccess(courses))
    } catch (e) {
        dispatch(dashboardActions.getOurCoursesError(e.message))
    }
}

export const getUpcomingClasses = () => async dispatch => {
    dispatch(dashboardActions.getUpcomingClasses())
    try {
        const courses = await fetchTopSellingClasses()
        dispatch(dashboardActions.getUpcomingClassesSuccess(courses))
    } catch (e) {
        dispatch(dashboardActions.getUpcomingClassesSuccess(e.message))
    }
}

export const getCourseProgress = () => async dispatch => {
    dispatch(dashboardActions.getUserCourses())
    try {
        const courses = await fetchUserCourses()
        dispatch(dashboardActions.getUserCoursesSuccess(courses))
    } catch (e) {
        dispatch(dashboardActions.getUserCoursesError(e.message))
    }
}

export const getBusinessUserStatistics = () => async dispatch => {
    dispatch(dashboardActions.getBusinessUserStatistics())
    try {
        const response = await fetchCachedHelper(
            `v1/dashboards/business/total-courses`
        )
        let businessUserStatistics = response.data

        dispatch(
            dashboardActions.getBusinessUserStatisticsSuccess(
                businessUserStatistics
            )
        )
    } catch (e) {
        dispatch(dashboardActions.getBusinessUserStatisticsError(e.message))
    }
}

export const getCompletionRate = params => async dispatch => {
    dispatch(dashboardActions.getCompletionRate())
    try {
        const response = await fetchCachedHelper(
            `v1/dashboards/business/completion-rate`,
            {
                params,
            }
        )
        let completionRate = response.data

        dispatch(dashboardActions.getCompletionRateSuccess(completionRate))
    } catch (e) {
        dispatch(dashboardActions.getCompletionRateError(e.message))
    }
}

export const getLeaderboard = () => async dispatch => {
    dispatch(dashboardActions.getLeaderboard())
    try {
        const response = await fetchCachedHelper(
            `v1/dashboards/business/leaderboard`
        )
        let leaderboard = response.data

        dispatch(dashboardActions.getLeaderboardSuccess(leaderboard))
    } catch (e) {
        dispatch(dashboardActions.getLeaderboardError(e.message))
    }
}

export const getBusinessUserCourses = params => async dispatch => {
    dispatch(dashboardActions.getBusinessUserCourses())
    try {
        const response = await fetchCachedHelper(
            `v1/dashboards/business/dashboard-courses`,
            { params }
        )
        let businessUserCourses = response.data

        dispatch(
            dashboardActions.getBusinessUserCoursesSuccess(businessUserCourses)
        )
    } catch (e) {
        dispatch(dashboardActions.getBusinessUserCoursesError(e.message))
    }
}

export const getCourseBeneficiaries = (
    courseCode,
    params
) => async dispatch => {
    dispatch(dashboardActions.getCourseBeneficiaries())
    try {
        const response = await fetchCachedHelper(
            `v1/dashboards/business/progress/${courseCode}`,
            { params }
        )
        let courseBeneficiaries = response.data

        dispatch(
            dashboardActions.getCourseBeneficiariesSuccess(courseBeneficiaries)
        )
    } catch (e) {
        dispatch(dashboardActions.getCourseBeneficiariesError(e.message))
    }
}
